(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["featured-product"] && !window.DesignMode) return;
  try {
    
let btn = $('button[id^="AddToCart"]')
let show = btn.data('anim_activate')
let type = btn.data('anim_type')
let delay = btn.data('anim_delay')
if (show == true){
	setInterval(function(){
		btn.animateCss(type,function(){
			btn.removeClass('animated').removeClass(type)
		})
	},delay*1000)
}


$('[name="qtyBtn"]').change(function(){
	$('#Quantity').val(parseInt($('[name="qtyBtn"]:checked').val()))
$("span[id^=ProductPrice]").html(theme.Currency.formatMoney($("span[id^=ProductPrice]").attr("content").replace('.', '') * $('[name="qtyBtn"]:checked').val(), theme.moneyFormat));
$("s[id^=ComparePrice-]").html(theme.Currency.formatMoney($("s[id^=ComparePrice-]").attr("content").replace('.', '') * $('[name="qtyBtn"]:checked').val(), theme.moneyFormat));
if($('[name="qtyBtn"]:checked').val() > 1){
$('.product-price__sale-label').hide()
$('.eco').css({"visibility":"visible"});
$('.ecoe').html(theme.Currency.formatMoney(($("s[id^=ComparePrice-]").attr("content").replace('.', '') * $('[name="qtyBtn"]:checked').val()) - ($("span[id^=ProductPrice]").attr("content").replace('.', '') * $('[name="qtyBtn"]:checked').val()), theme.moneyFormat) );
}
else{
$('.product-price__sale-label').hide();
$('.eco').css({"visibility":"hidden"});
}

if($('[name="qtyBtn"]:checked').val() == 3){
$('.product-price__sale-label').css({'display':'flex'});
}

})


$('.single-option-selector-Quantité').change(function(){
	if ($('.single-option-selector-Quantité').val() == "Pack de 3"){
$('.product-price__sale-label').text('MEILLEURE VENTE');
$('.product-price__sale-label').css({'display':'flex'});

}
else if ( $('.single-option-selector-Quantité').val() == "Pack de 5"){
$('.product-price__sale-label').text('RECOMMANDÉ') ;
$('.product-price__sale-label').css({'display':'flex'});
}

else{
$('.product-price__sale-label').hide();
}

	if ($('.single-option-selector-Quantité').val() == "Pack de 3" || $('.single-option-selector-Quantité').val() == "Pack de 5"){
$('.eco').css({"visibility":"visible"});
}
else {
$('.eco').css({"visibility":"hidden"}); 
}




})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

$('#AddToCart-product-template').click(function(){

$.get( "/cart.json", function( data ) {

$('.zone-elem-cart').empty();
$.each(data.items, function(index, value){
$('.zone-elem-cart').append("<div style='display:flex;margin-top:16px; justify-content:space-between'><div style='display:flex;width:100%'><a href='"+data.items[index].url+"' style='padding:0 !important'><img src='"+ data.items[index].featured_image.url+"' width='67px' style='min-width:67px'/></a><div style='margin-left:20px;width:100%'><a href='"+data.items[index].url+"' style='padding:0!important'> <div style='font-weight:400; font-size:14px; line-height:22px'><b>"+data.items[index].product_title+"</b></div> <div style='font-line:16px; font-size:11px;color:#788188'>"+data.items[index].variant_title+"</div></a><div class='mt-1' style='font-size:14px;display:flex;align-items:center;width:100%;justify-content:space-between'><div style='display:flex' data-id='"+data.items[index].id+"'> <button class='qty_button minus_cart'>-</button><input type='numeric' class='cart_qty' value='"+data.items[index].quantity+"'/><button class='qty_button plus_cart'>+</button></div> <div style='font-size:16px;'>"+(data.items[index].line_price/100).toFixed(2).replace(/\./g, ',')+"€</div></div>  </div>  </div> </div>")
})
$('.zone-elem-cart').append(' <div style="border-top:1px solid #e9e7e7;margin-top:20px;padding-top:20px">  <div style="display:flex;justify-content:space-between; font-weight:600;align-items:center">TOTAL TTC:<div class="price_cartonpage" style="font-size:16px">'+(data.total_price/100).toFixed(2).replace(/\./g, ',')+'€</div></div> <a href="/checkout" style="padding: 0!important;"><input type="button" style="width:100%;box-shadow: 0 3px 0px 0px #db8abd;margin-top:20px" class="btn btn--small-wide cart_buy_button" value="Passer commande"></a><div class="text-center" style="margin-top:10px;"><a href="" class="close-cart" style="padding:0!important; font-size:16px;text-align:center; font-family:bebas neue;color:#ffa8cb;margin-top:15px">Continuer mes achats</a></div> </div>');
},"json")
});

var posScroll;
$('.burger1').click(function(e){
event.preventDefault()
        
posScroll =  $(window).scrollTop()

$('.overlay-header-1').addClass('opac')
$('.menu-header1').addClass('active')
$('body').css({'overflow-y':'hidden','position':'fixed','width':'100%', 'top': '-'+ $(window).scrollTop()+ 'px' });
$('#shopify-section-hero').css({'position':'relative'});
if ($('.site-header2.scroll-header').css('opacity') == "1"){
$('.site-header2.scroll-header').addClass('test')
};
})
$('.close-header1').click(function(){
var opacity = $('.site-header2.scroll-header').css('opacity');

$('body').css({'overflow-y': 'auto','position':'relative', 'top': '0'});
$(document).scrollTop(posScroll);
$('.overlay-header-1').removeClass('opac');
$('.menu-header1').removeClass('active');
document.body.style.top = '';
setTimeout(function(){ $('.site-header2.scroll-header').removeClass('test') }, 100);

});






  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newheader"]) return;
  try {
    

$('#AddToCart-product-template').click(function(){

$.get( "/cart.json", function( data ) {

$('.zone-elem-cart').empty();
$.each(data.items, function(index, value){
$('.zone-elem-cart').append("<div style='display:flex;margin-top:16px; justify-content:space-between'><div style='display:flex;width:100%'><a href='"+data.items[index].url+"' style='padding:0 !important'><img src='"+ data.items[index].featured_image.url+"' width='67px' style='min-width:67px'/></a><div style='margin-left:20px;width:100%'><a href='"+data.items[index].url+"' style='padding:0!important'> <div style='font-weight:400; font-size:14px; line-height:22px'><b>"+data.items[index].product_title+"</b></div> <div style='font-line:16px; font-size:11px;color:#788188'>"+data.items[index].variant_title+"</div></a><div class='mt-1' style='font-size:14px;display:flex;align-items:center;width:100%;justify-content:space-between'><div style='display:flex' data-id='"+data.items[index].id+"'> <button class='qty_button minus_cart'>-</button><input type='numeric' class='cart_qty' value='"+data.items[index].quantity+"'/><button class='qty_button plus_cart'>+</button></div> <div style='font-size:16px;'>"+(data.items[index].line_price/100).toFixed(2).replace(/\./g, ',')+"€</div></div>  </div>  </div> </div>")
})
$('.zone-elem-cart').append(' <div style="border-top:1px solid #e9e7e7;margin-top:20px;padding-top:20px">  <div style="display:flex;justify-content:space-between; font-weight:600;align-items:center">TOTAL TTC:<div class="price_cartonpage" style="font-size:16px">'+(data.total_price/100).toFixed(2).replace(/\./g, ',')+'€</div></div> <a href="/checkout" style="padding: 0!important;"><input type="button" style="width:100%;box-shadow: 0 3px 0px 0px #db8abd;margin-top:20px" class="btn btn--small-wide cart_buy_button" value="Passer commande"></a><div class="text-center" style="margin-top:10px;"><a href="" class="close-cart" style="padding:0!important; font-size:16px;text-align:center; font-family:bebas neue;color:#ffa8cb;margin-top:15px">Continuer mes achats</a></div> </div>');
},"json")
});







  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-gift"]) return;
  try {
    

$('.single-option-selector-Quantité').change(function(){
	if ($('.single-option-selector-Quantité').val() == "Pack de 3"){
$('.product-price__sale-label').css({'display':'flex'});

}
else{
$('.product-price__sale-label').hide();
}

	if ($('.single-option-selector-Quantité').val() == "Pack de 3" || $('.single-option-selector-Quantité').val() == "Pack de 5"){
$('.eco').css({"visibility":"visible"}) ;
}
else {
$('.eco').css({"visibility":"hidden"}); 
}
})

                   $('[name="qtyBtn"]').change(function(){
	$('#Quantity').val(parseInt($('[name="qtyBtn"]:checked').val()))
$("span[id^=ProductPrice]").html(theme.Currency.formatMoney($("span[id^=ProductPrice]").attr("content").replace('.', '') * $('[name="qtyBtn"]:checked').val(), theme.moneyFormat));
$("s[id^=ComparePrice-]").html(theme.Currency.formatMoney($("s[id^=ComparePrice-]").attr("content").replace('.', '') * $('[name="qtyBtn"]:checked').val(), theme.moneyFormat));
if($('[name="qtyBtn"]:checked').val() > 1){
$('.product-price__sale-label').hide()
$('.eco').css({"visibility":"visible"});
$('.ecoe').html(theme.Currency.formatMoney(($("s[id^=ComparePrice-]").attr("content").replace('.', '') * $('[name="qtyBtn"]:checked').val()) - ($("span[id^=ProductPrice]").attr("content").replace('.', '') * $('[name="qtyBtn"]:checked').val()), theme.moneyFormat) );
}
else{
$('.product-price__sale-label').hide();
$('.eco').css({"visibility":"hidden"});
}

if($('[name="qtyBtn"]:checked').val() == 3){
$('.product-price__sale-label').css({'display':'flex'})
}

});

moment.locale("fr")

function addWeekdays(date, days) {
  date = moment(date); // use a clone
  while (days > 0) {
  	date = date.add(1, 'days');
    // decrease "days" only if it's a weekday.
    if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) {
    	days -= 1;
    }
}
return date;
}


let btn = $('#AddToCart-product-template')
let show = btn.data('anim_activate')
let type = btn.data('anim_type')
let delay = btn.data('anim_delay')
if (show == true){
	setInterval(function(){
		btn.animateCss(type,function(){
			btn.removeClass('animated').removeClass(type)
		})
	},delay*1000)
}

let watching_start = Math.floor(Math.random() * (50-10+1) + 10)
let watching_text_people_origin = $('#marketing_watching_nb_text').data('personnes')
let watching_text_text = $('#marketing_watching_nb_text').data('watchingtext')

let watching_text_people = watching_text_people_origin.replace("[nb]",watching_start)

$('#marketing_watching_nb_text').html('<span class="marketing_watching_bold">'+watching_text_people+'</span> '+watching_text_text)

setInterval(function(){
	if (Math.random() < 0.5){
		if(watching_start >= 10){
			watching_start++ 
		}
		else{
			watching_start--
		}
	}
	else{
		if(watching_start <= 50){
			watching_start--
		}
		else{
			watching_start++
		}
	}
	if(watching_start<0){
		watching_start=-watching_start
	}
	watching_text_people = watching_text_people_origin.replace("[nb]",watching_start)
	$('#marketing_watching_nb_text').html('<span class="marketing_watching_bold">'+watching_text_people+'</span> '+watching_text_text)
	console.log(watching_text_people)
},5000)


let commands_start_text_bolded = $('#marketing_commands_text').data('bolded')
let commands_start_text = $('#marketing_commands_text').data('text')
let commands_start = Math.floor(Math.random() * (20-1+1) + 1)

commands_start_text_bolded_new = commands_start_text_bolded.replace('[nb]',commands_start)
commands_start_text_new = commands_start_text.replace('[bold]','<span class="marketing_watching_bold">'+commands_start_text_bolded_new+'</span>')

$('#marketing_commands_text').html(commands_start_text_new)
setInterval(function(){
	if (Math.random() < 0.5){
		commands_start--                 
	}
	else{
		commands_start++
	}
	if(commands_start<0){
		commands_start=-commands_start
	}
	commands_start_text_bolded_new = commands_start_text_bolded.replace('[nb]',commands_start)
	commands_start_text_new = commands_start_text.replace('[bold]','<span class="marketing_watching_bold">'+commands_start_text_bolded_new+'</span>')
	$('#marketing_commands_text').html(commands_start_text_new)
},8000);


let marketing_shipping_day_text_question = $('#marketing_shipping_day_text').data('questiontext')
let marketing_shipping_day_text_timertext = $('#marketing_shipping_day_text').data('timertext')
let marketing_shipping_day_text_color = $('#marketing_shipping_day_text').data('color')

let marketing_shipping_day_min = $('#marketing_shipping_day_text').data('min')
let marketing_shipping_day_max = $('#marketing_shipping_day_text').data('max')



let arrAvg = arr => arr.reduce((a,b) => a + b, 0) / arr.length
let shipping_time = Math.round(arrAvg([marketing_shipping_day_min,marketing_shipping_day_max]))
let shipping_time_to = addWeekdays(moment(),shipping_time)
let shipping_time_text = shipping_time_to.format("dddd DD MMM")

marketing_shipping_day_text_question = marketing_shipping_day_text_question.replace('[date]',shipping_time_text.charAt(0).toUpperCase() + shipping_time_text.substr(1))

$('#marketing_shipping_day_text').html('<span class="marketing_watching_bold">'+marketing_shipping_day_text_question+'</span>')

var countDownDate = moment().add(1,'d').hours(5).minutes(0).toDate()

var countDownOffer = moment().add(73101,'s').toDate()

// Update the count down every 1 second
var x = setInterval(function() {

  // Get todays date and time
  var now = new Date().getTime();

  // Find the distance between now and the count down date
  var distance = countDownDate - now;
  var distanceOffer = countDownOffer - now;
  let distanceOfferOld = distanceOffer

  if (window.localStorage.getItem('countdown_old') == null){
  	window.localStorage.setItem('countdown_old',distanceOffer)
  }
  else{
//console.log(window.localStorage.getItem('countdown_old'),distanceOffer)
window.localStorage.setItem('countdown_old', distanceOffer)
distanceOffer = window.localStorage.getItem('countdown_old')

}

  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  var daysOffer = Math.floor(distanceOffer / (1000 * 60 * 60 * 24));
  var hoursOffer = Math.floor((distanceOffer % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutesOffer = Math.floor((distanceOffer % (1000 * 60 * 60)) / (1000 * 60));
  var secondsOffer = Math.floor((distanceOffer % (1000 * 60)) / 1000);
  
  marketing_shipping_day_text_timertext = marketing_shipping_day_text_timertext.replace('[date]','<span id="marketing_watching_date" style="color:' + marketing_shipping_day_text_color + ';font-weight:bold;" >'+(hours + "h " + minutes + "mins")+'</span>')
  $('#marketing_shipping_day_text').html('<span class="marketing_watching_bold">'+marketing_shipping_day_text_question+'</span> '+marketing_shipping_day_text_timertext)
  //$('#marketing_watching_date').html(hours + "h " + minutes + "mins")


	
	let marketing_countdown_date_jours = $('#marketing_countdown_text').data('jours')
	let marketing_countdown_date_heures = $('#marketing_countdown_text').data('heures')
	let marketing_countdown_date_minutes = $('#marketing_countdown_text').data('minutes')
	let marketing_countdown_date_secondes = $('#marketing_countdown_text').data('secondes')
	let marketing_countdown_color = $('#marketing_countdown_text').data('color')
	let marketing_countdown_text = $('#marketing_countdown_text').data('text')
	marketing_countdown_text = marketing_countdown_text.replace('[timer]','<span style="color:'+ marketing_countdown_color +';font-weight:bold;">'+("0" + daysOffer).slice(-2)+" "+marketing_countdown_date_jours+" "+ ("0" + hoursOffer).slice(-2) + " "+marketing_countdown_date_heures+" " + ("0" + minutesOffer).slice(-2) + " "+marketing_countdown_date_minutes+" "+  ("0" + secondsOffer).slice(-2) + " "+marketing_countdown_date_secondes + "</span>")
	
	$('#marketing_countdown_text').html(marketing_countdown_text)

	let marketing_countdown_date_text = 'Plus que 00 jours 00 heures 00 minutes 00 secondes pour profitez'


  // If the count down is finished, write some text 
  if (distance < 0) {
  	countDownDate = moment().add(1,'d').hours(5).minutes(0).toDate()
  	countDownOffer = moment().add(1,'d').hours(5).minutes(0).toDate()
  }
}, 1000);

/*$(function(){
if($('#AddToCart-product-template').data('loaderon') == true){
	$('#AddToCart-product-template').click(function(){
		$("#AddToCart-product-template span").html('<center style="padding:0;background:none;"><div class="loader"></div></center>')
	})
}
})*/
         
                   


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    

$('.single-option-selector-Quantité').change(function(){
	if ($('.single-option-selector-Quantité').val() == "Pack de 3"){
$('.product-price__sale-label').css({'display':'flex'});

}
else{
$('.product-price__sale-label').hide();
}

	if ($('.single-option-selector-Quantité').val() == "Pack de 3" || $('.single-option-selector-Quantité').val() == "Pack de 5"){
$('.eco').css({"visibility":"visible"}) ;
}
else {
$('.eco').css({"visibility":"hidden"}); 
}
})

                   $('[name="qtyBtn"]').change(function(){
	$('#Quantity').val(parseInt($('[name="qtyBtn"]:checked').val()))
$("span[id^=ProductPrice]").html(theme.Currency.formatMoney($("span[id^=ProductPrice]").attr("content").replace('.', '') * $('[name="qtyBtn"]:checked').val(), theme.moneyFormat));
$("s[id^=ComparePrice-]").html(theme.Currency.formatMoney($("s[id^=ComparePrice-]").attr("content").replace('.', '') * $('[name="qtyBtn"]:checked').val(), theme.moneyFormat));
if($('[name="qtyBtn"]:checked').val() > 1){
$('.product-price__sale-label').hide()
$('.eco').css({"visibility":"visible"});
$('.ecoe').html(theme.Currency.formatMoney(($("s[id^=ComparePrice-]").attr("content").replace('.', '') * $('[name="qtyBtn"]:checked').val()) - ($("span[id^=ProductPrice]").attr("content").replace('.', '') * $('[name="qtyBtn"]:checked').val()), theme.moneyFormat) );
}
else{
$('.product-price__sale-label').hide();
$('.eco').css({"visibility":"hidden"});
}

if($('[name="qtyBtn"]:checked').val() == 3){
$('.product-price__sale-label').css({'display':'flex'})
}

});

moment.locale("fr")

function addWeekdays(date, days) {
  date = moment(date); // use a clone
  while (days > 0) {
  	date = date.add(1, 'days');
    // decrease "days" only if it's a weekday.
    if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) {
    	days -= 1;
    }
}
return date;
}


let btn = $('#AddToCart-product-template')
let show = btn.data('anim_activate')
let type = btn.data('anim_type')
let delay = btn.data('anim_delay')
if (show == true){
	setInterval(function(){
		btn.animateCss(type,function(){
			btn.removeClass('animated').removeClass(type)
		})
	},delay*1000)
}

let watching_start = Math.floor(Math.random() * (50-10+1) + 10)
let watching_text_people_origin = $('#marketing_watching_nb_text').data('personnes')
let watching_text_text = $('#marketing_watching_nb_text').data('watchingtext')

let watching_text_people = watching_text_people_origin.replace("[nb]",watching_start)

$('#marketing_watching_nb_text').html('<span class="marketing_watching_bold">'+watching_text_people+'</span> '+watching_text_text)

setInterval(function(){
	if (Math.random() < 0.5){
		if(watching_start >= 10){
			watching_start++ 
		}
		else{
			watching_start--
		}
	}
	else{
		if(watching_start <= 50){
			watching_start--
		}
		else{
			watching_start++
		}
	}
	if(watching_start<0){
		watching_start=-watching_start
	}
	watching_text_people = watching_text_people_origin.replace("[nb]",watching_start)
	$('#marketing_watching_nb_text').html('<span class="marketing_watching_bold">'+watching_text_people+'</span> '+watching_text_text)
	console.log(watching_text_people)
},5000)


let commands_start_text_bolded = $('#marketing_commands_text').data('bolded')
let commands_start_text = $('#marketing_commands_text').data('text')
let commands_start = Math.floor(Math.random() * (20-1+1) + 1)

commands_start_text_bolded_new = commands_start_text_bolded.replace('[nb]',commands_start)
commands_start_text_new = commands_start_text.replace('[bold]','<span class="marketing_watching_bold">'+commands_start_text_bolded_new+'</span>')

$('#marketing_commands_text').html(commands_start_text_new)
setInterval(function(){
	if (Math.random() < 0.5){
		commands_start--                 
	}
	else{
		commands_start++
	}
	if(commands_start<0){
		commands_start=-commands_start
	}
	commands_start_text_bolded_new = commands_start_text_bolded.replace('[nb]',commands_start)
	commands_start_text_new = commands_start_text.replace('[bold]','<span class="marketing_watching_bold">'+commands_start_text_bolded_new+'</span>')
	$('#marketing_commands_text').html(commands_start_text_new)
},8000);


let marketing_shipping_day_text_question = $('#marketing_shipping_day_text').data('questiontext')
let marketing_shipping_day_text_timertext = $('#marketing_shipping_day_text').data('timertext')
let marketing_shipping_day_text_color = $('#marketing_shipping_day_text').data('color')

let marketing_shipping_day_min = $('#marketing_shipping_day_text').data('min')
let marketing_shipping_day_max = $('#marketing_shipping_day_text').data('max')



let arrAvg = arr => arr.reduce((a,b) => a + b, 0) / arr.length
let shipping_time = Math.round(arrAvg([marketing_shipping_day_min,marketing_shipping_day_max]))
let shipping_time_to = addWeekdays(moment(),shipping_time)
let shipping_time_text = shipping_time_to.format("dddd DD MMM")

marketing_shipping_day_text_question = marketing_shipping_day_text_question.replace('[date]',shipping_time_text.charAt(0).toUpperCase() + shipping_time_text.substr(1))

$('#marketing_shipping_day_text').html('<span class="marketing_watching_bold">'+marketing_shipping_day_text_question+'</span>')

var countDownDate = moment().add(1,'d').hours(5).minutes(0).toDate()

var countDownOffer = moment().add(73101,'s').toDate()

// Update the count down every 1 second
var x = setInterval(function() {

  // Get todays date and time
  var now = new Date().getTime();

  // Find the distance between now and the count down date
  var distance = countDownDate - now;
  var distanceOffer = countDownOffer - now;
  let distanceOfferOld = distanceOffer

  if (window.localStorage.getItem('countdown_old') == null){
  	window.localStorage.setItem('countdown_old',distanceOffer)
  }
  else{
//console.log(window.localStorage.getItem('countdown_old'),distanceOffer)
window.localStorage.setItem('countdown_old', distanceOffer)
distanceOffer = window.localStorage.getItem('countdown_old')

}

  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  var daysOffer = Math.floor(distanceOffer / (1000 * 60 * 60 * 24));
  var hoursOffer = Math.floor((distanceOffer % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutesOffer = Math.floor((distanceOffer % (1000 * 60 * 60)) / (1000 * 60));
  var secondsOffer = Math.floor((distanceOffer % (1000 * 60)) / 1000);
  
  marketing_shipping_day_text_timertext = marketing_shipping_day_text_timertext.replace('[date]','<span id="marketing_watching_date" style="color:' + marketing_shipping_day_text_color + ';font-weight:bold;" >'+(hours + "h " + minutes + "mins")+'</span>')
  $('#marketing_shipping_day_text').html('<span class="marketing_watching_bold">'+marketing_shipping_day_text_question+'</span> '+marketing_shipping_day_text_timertext)
  //$('#marketing_watching_date').html(hours + "h " + minutes + "mins")


	
	let marketing_countdown_date_jours = $('#marketing_countdown_text').data('jours')
	let marketing_countdown_date_heures = $('#marketing_countdown_text').data('heures')
	let marketing_countdown_date_minutes = $('#marketing_countdown_text').data('minutes')
	let marketing_countdown_date_secondes = $('#marketing_countdown_text').data('secondes')
	let marketing_countdown_color = $('#marketing_countdown_text').data('color')
	let marketing_countdown_text = $('#marketing_countdown_text').data('text')
	marketing_countdown_text = marketing_countdown_text.replace('[timer]','<span style="color:'+ marketing_countdown_color +';font-weight:bold;">'+("0" + daysOffer).slice(-2)+" "+marketing_countdown_date_jours+" "+ ("0" + hoursOffer).slice(-2) + " "+marketing_countdown_date_heures+" " + ("0" + minutesOffer).slice(-2) + " "+marketing_countdown_date_minutes+" "+  ("0" + secondsOffer).slice(-2) + " "+marketing_countdown_date_secondes + "</span>")
	
	$('#marketing_countdown_text').html(marketing_countdown_text)

	let marketing_countdown_date_text = 'Plus que 00 jours 00 heures 00 minutes 00 secondes pour profitez'


  // If the count down is finished, write some text 
  if (distance < 0) {
  	countDownDate = moment().add(1,'d').hours(5).minutes(0).toDate()
  	countDownOffer = moment().add(1,'d').hours(5).minutes(0).toDate()
  }
}, 1000);

/*$(function(){
if($('#AddToCart-product-template').data('loaderon') == true){
	$('#AddToCart-product-template').click(function(){
		$("#AddToCart-product-template span").html('<center style="padding:0;background:none;"><div class="loader"></div></center>')
	})
}
})*/
         
                   


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template2"]) return;
  try {
    
$('.button_add_cart').click(function(){
$('#AddToCart-product-template2').click();


})
$('.single-option-selector-Quantité').change(function(){


	if ($('.single-option-selector-Quantité').val() == "Pack de 3"){
$('.product-price__sale-label').text('MEILLEURE VENTE') ;
$('.product-price__sale-label').css({'display':'flex'});

}
else if ( $('.single-option-selector-Quantité').val() == "Pack de 5"){
$('.product-price__sale-label').text('RECOMMANDÉ') ;
$('.product-price__sale-label').css({'display':'flex'});
}

else{
$('.product-price__sale-label').hide();
}

	if ($('.single-option-selector-Quantité').val() == "Pack de 3" || $('.single-option-selector-Quantité').val() == "Pack de 5"){
$('.eco').css({"visibility":"visible"}) ;
}
else {
$('.eco').css({"visibility":"hidden"}); 
}
})

                   $('[name="qtyBtn"]').change(function(){
	$('#Quantity').val(parseInt($('[name="qtyBtn"]:checked').val()))
$("span[id^=ProductPrice]").html(theme.Currency.formatMoney($("span[id^=ProductPrice]").attr("content").replace('.', '') * $('[name="qtyBtn"]:checked').val(), theme.moneyFormat));
$("s[id^=ComparePrice-]").html(theme.Currency.formatMoney($("s[id^=ComparePrice-]").attr("content").replace('.', '') * $('[name="qtyBtn"]:checked').val(), theme.moneyFormat));
if($('[name="qtyBtn"]:checked').val() > 1){
$('.product-price__sale-label').hide()
$('.eco').css({"visibility":"visible"});
$('.ecoe').html(theme.Currency.formatMoney(($("s[id^=ComparePrice-]").attr("content").replace('.', '') * $('[name="qtyBtn"]:checked').val()) - ($("span[id^=ProductPrice]").attr("content").replace('.', '') * $('[name="qtyBtn"]:checked').val()), theme.moneyFormat) );
}
else{
$('.product-price__sale-label').hide();
$('.eco').css({"visibility":"hidden"});
}

if($('[name="qtyBtn"]:checked').val() == 3){
$('.product-price__sale-label').css({'display':'flex'})
}

});

moment.locale("fr")

function addWeekdays(date, days) {
  date = moment(date); // use a clone
  while (days > 0) {
  	date = date.add(1, 'days');
    // decrease "days" only if it's a weekday.
    if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) {
    	days -= 1;
    }
}
return date;
}


let btn = $('#AddToCart-product-template')
let show = btn.data('anim_activate')
let type = btn.data('anim_type')
let delay = btn.data('anim_delay')
if (show == true){
	setInterval(function(){
		btn.animateCss(type,function(){
			btn.removeClass('animated').removeClass(type)
		})
	},delay*1000)
}

let watching_start = Math.floor(Math.random() * (50-10+1) + 10)
let watching_text_people_origin = $('#marketing_watching_nb_text').data('personnes')
let watching_text_text = $('#marketing_watching_nb_text').data('watchingtext')

let watching_text_people = watching_text_people_origin.replace("[nb]",watching_start)

$('#marketing_watching_nb_text').html('<span class="marketing_watching_bold">'+watching_text_people+'</span> '+watching_text_text)

setInterval(function(){
	if (Math.random() < 0.5){
		if(watching_start >= 10){
			watching_start++ 
		}
		else{
			watching_start--
		}
	}
	else{
		if(watching_start <= 50){
			watching_start--
		}
		else{
			watching_start++
		}
	}
	if(watching_start<0){
		watching_start=-watching_start
	}
	watching_text_people = watching_text_people_origin.replace("[nb]",watching_start)
	$('#marketing_watching_nb_text').html('<span class="marketing_watching_bold">'+watching_text_people+'</span> '+watching_text_text)
	console.log(watching_text_people)
},5000)


let commands_start_text_bolded = $('#marketing_commands_text').data('bolded')
let commands_start_text = $('#marketing_commands_text').data('text')
let commands_start = Math.floor(Math.random() * (20-1+1) + 1)

commands_start_text_bolded_new = commands_start_text_bolded.replace('[nb]',commands_start)
commands_start_text_new = commands_start_text.replace('[bold]','<span class="marketing_watching_bold">'+commands_start_text_bolded_new+'</span>')

$('#marketing_commands_text').html(commands_start_text_new)
setInterval(function(){
	if (Math.random() < 0.5){
		commands_start--                 
	}
	else{
		commands_start++
	}
	if(commands_start<0){
		commands_start=-commands_start
	}
	commands_start_text_bolded_new = commands_start_text_bolded.replace('[nb]',commands_start)
	commands_start_text_new = commands_start_text.replace('[bold]','<span class="marketing_watching_bold">'+commands_start_text_bolded_new+'</span>')
	$('#marketing_commands_text').html(commands_start_text_new)
},8000);


let marketing_shipping_day_text_question = $('#marketing_shipping_day_text').data('questiontext')
let marketing_shipping_day_text_timertext = $('#marketing_shipping_day_text').data('timertext')
let marketing_shipping_day_text_color = $('#marketing_shipping_day_text').data('color')

let marketing_shipping_day_min = $('#marketing_shipping_day_text').data('min')
let marketing_shipping_day_max = $('#marketing_shipping_day_text').data('max')



let arrAvg = arr => arr.reduce((a,b) => a + b, 0) / arr.length
let shipping_time = Math.round(arrAvg([marketing_shipping_day_min,marketing_shipping_day_max]))
let shipping_time_to = addWeekdays(moment(),shipping_time)
let shipping_time_text = shipping_time_to.format("dddd DD MMM")

marketing_shipping_day_text_question = marketing_shipping_day_text_question.replace('[date]',shipping_time_text.charAt(0).toUpperCase() + shipping_time_text.substr(1))

$('#marketing_shipping_day_text').html('<span class="marketing_watching_bold">'+marketing_shipping_day_text_question+'</span>')

var countDownDate = moment().add(1,'d').hours(5).minutes(0).toDate()

var countDownOffer = moment().add(73101,'s').toDate()

// Update the count down every 1 second
var x = setInterval(function() {

  // Get todays date and time
  var now = new Date().getTime();

  // Find the distance between now and the count down date
  var distance = countDownDate - now;
  var distanceOffer = countDownOffer - now;
  let distanceOfferOld = distanceOffer

  if (window.localStorage.getItem('countdown_old') == null){
  	window.localStorage.setItem('countdown_old',distanceOffer)
  }
  else{
//console.log(window.localStorage.getItem('countdown_old'),distanceOffer)
window.localStorage.setItem('countdown_old', distanceOffer)
distanceOffer = window.localStorage.getItem('countdown_old')

}

  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  var daysOffer = Math.floor(distanceOffer / (1000 * 60 * 60 * 24));
  var hoursOffer = Math.floor((distanceOffer % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutesOffer = Math.floor((distanceOffer % (1000 * 60 * 60)) / (1000 * 60));
  var secondsOffer = Math.floor((distanceOffer % (1000 * 60)) / 1000);
  
  marketing_shipping_day_text_timertext = marketing_shipping_day_text_timertext.replace('[date]','<span id="marketing_watching_date" style="color:' + marketing_shipping_day_text_color + ';font-weight:bold;" >'+(hours + "h " + minutes + "mins")+'</span>')
  $('#marketing_shipping_day_text').html('<span class="marketing_watching_bold">'+marketing_shipping_day_text_question+'</span> '+marketing_shipping_day_text_timertext)
  //$('#marketing_watching_date').html(hours + "h " + minutes + "mins")


	
	let marketing_countdown_date_jours = $('#marketing_countdown_text').data('jours')
	let marketing_countdown_date_heures = $('#marketing_countdown_text').data('heures')
	let marketing_countdown_date_minutes = $('#marketing_countdown_text').data('minutes')
	let marketing_countdown_date_secondes = $('#marketing_countdown_text').data('secondes')
	let marketing_countdown_color = $('#marketing_countdown_text').data('color')
	let marketing_countdown_text = $('#marketing_countdown_text').data('text')
	marketing_countdown_text = marketing_countdown_text.replace('[timer]','<span style="color:'+ marketing_countdown_color +';font-weight:bold;">'+("0" + daysOffer).slice(-2)+" "+marketing_countdown_date_jours+" "+ ("0" + hoursOffer).slice(-2) + " "+marketing_countdown_date_heures+" " + ("0" + minutesOffer).slice(-2) + " "+marketing_countdown_date_minutes+" "+  ("0" + secondsOffer).slice(-2) + " "+marketing_countdown_date_secondes + "</span>")
	
	$('#marketing_countdown_text').html(marketing_countdown_text)

	let marketing_countdown_date_text = 'Plus que 00 jours 00 heures 00 minutes 00 secondes pour profitez'


  // If the count down is finished, write some text 
  if (distance < 0) {
  	countDownDate = moment().add(1,'d').hours(5).minutes(0).toDate()
  	countDownOffer = moment().add(1,'d').hours(5).minutes(0).toDate()
  }
}, 1000);

/*$(function(){
if($('#AddToCart-product-template').data('loaderon') == true){
	$('#AddToCart-product-template').click(function(){
		$("#AddToCart-product-template span").html('<center style="padding:0;background:none;"><div class="loader"></div></center>')
	})
}
})*/
                   
                   


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quotes"] && !window.DesignMode) return;
  try {
    

  
$('.multiple-items').slick({
  dots: false,
  infinite: true,
autoplay: true,
arrows : false,
adaptiveHeight:true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
pauseOnFocus :false,
pauseOnHover :false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
		centerMode :true
      }
    }

  ]
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommandation"]) return;
  try {
    
$(".slider-recommandation").slick({
	'autoplay':true,
    'arrows': false,
'slidesToShow': 5,
  'slidesToScroll': 1,
  'responsive': [

    {
      'breakpoint': 600,
      'settings': {
        'slidesToShow': 2,
        'slidesToScroll': 2
      }
    },
    {
      'breakpoint': 480,
      'settings': {
        'slidesToShow': 2,
        'slidesToScroll': 1
      }
    }
  ]
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slidePhoto"] && !window.DesignMode) return;
  try {
    



$('.slidePhoto').not('.slick-initialized').slick({
	arrows:false,
	autoplay:true,
autoplaySpeed: 0,
cssEase: 'linear',          
speed: speed,
draggable : false,
pauseOnFocus: false,
slidesToShow : $('.slidePhoto').data('nbrPhoto'),
variableWidth: true,
 

});



  } catch(e) { console.error(e); }
})();

})();
